import gql from "graphql-tag";

export default gql`
  fragment YearlyBrazilianCompanyFinancialsFields on YearlyBrazilianCompanyFinancials {
    ... on YearlyBrazilianBankFinancialStatementRow {
      fiscalYear
      totalAssets
      netEquity
      financialIntermediationRevenue
      incomeTaxes
      netIncome
      netIncomeFromDiscontinuedOperations
      provisionForCreditLossesToNetIncomeRatio
      netMargin
      returnOnEquity
      bisRatio
      provisionForCreditLosses
      payout
      payoutToNetIncomeRatio
      cashFlowForDividends
      cashFlowForDividendsToNetIncomeRatio
      humanReadableQuarter
      startOfPeriod
      endOfPeriod
      isTrailingTwelveMonths
    }

    ... on YearlyBrazilianCompanyFinancialStatementRow {
      fiscalYear
      netEquity
      netRevenue
      ebitda
      depreciationAndAmortization
      ebit
      ebitToNetRevenueRatio
      financialResult
      incomeTaxes
      incomeTaxesToTaxableProfitRatio
      netIncome
      netIncomeFromDiscontinuedOperations
      netMargin
      returnOnEquity
      cash
      debt
      netDebt
      debtToNetEquityRatio
      netDebtToEbitdaRatio
      cashFlowFromOperations
      capex
      cashFlowFromFinancing
      freeCashFlow
      capexToCashFlowFromOperationsRatio
      payout
      payoutToNetIncomeRatio
      cashFlowForDividends
      cashFlowForDividendsToNetIncomeRatio
      humanReadableQuarter
      startOfPeriod
      endOfPeriod
      isTrailingTwelveMonths
    }

    ... on YearlyBrazilianInsurerFinancialStatementRow {
      fiscalYear
      netEquity
      netRevenue
      ebitda
      depreciationAndAmortization
      ebit
      ebitToNetRevenueRatio
      financialResult
      incomeTaxes
      incomeTaxesToTaxableProfitRatio
      netIncome
      netIncomeFromDiscontinuedOperations
      netMargin
      returnOnEquity
      cash
      debt
      netDebt
      debtToNetEquityRatio
      netDebtToEbitdaRatio
      cashFlowFromOperations
      capex
      cashFlowFromFinancing
      freeCashFlow
      capexToCashFlowFromOperationsRatio
      payout
      payoutToNetIncomeRatio
      cashFlowForDividends
      cashFlowForDividendsToNetIncomeRatio
      humanReadableQuarter
      startOfPeriod
      endOfPeriod
      isTrailingTwelveMonths
    }
  }
`;
